// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-content_root__YvxqU"};